/*
  quiz.js - NOTFORTOMORROW OS2.0 - "Find Your Stack" 4-step quiz (vanilla, no deps).
  Progressive enhancement: with JS OFF the server renders step 1 + every step is in the DOM,
  so a visitor still sees the question. JS turns it into a single-step wizard with a progress
  header (STEP n OF 4 / pct%), Back/Next nav, radio selection, and a mapped RESULT card.

  The GOAL chosen in step 1 maps to one of the 6 stacks. The result card names the stack,
  links to /pages/bundels, and exposes an "Add bundle" button ([data-add-bundle]) wired to
  bundle-add.js with that stack's real product handles. No fabricated savings - any discount
  is the live store's active automatic discount, shown the way the live site shows it.
*/
(function () {
  'use strict';

  document.querySelectorAll('[data-quiz]').forEach(function (root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-step]'));
    var result = root.querySelector('[data-quiz-result]');
    if (!steps.length) return;

    var total = steps.length;
    var current = 0;
    var answers = {};

    var bar = root.querySelector('[data-quiz-bar]');
    var counter = root.querySelector('[data-quiz-counter]');
    var pctEl = root.querySelector('[data-quiz-pct]');
    var live = root.querySelector('[data-quiz-progress-live]');

    // Map a goal value to its recommended stack (name + handles + page anchor).
    // The stack + goal-stack map nodes live in the section, OUTSIDE the [data-quiz] card,
    // so resolve them from the section scope (querying from root alone finds nothing = every
    // goal would wrongly fall back to the default stack).
    var scope = root.closest('[data-section-id]') || root.closest('.nfp-quiz') || document;
    var stacks = {};
    scope.querySelectorAll('[data-stack]').forEach(function (node) {
      stacks[node.getAttribute('data-stack')] = {
        name: node.getAttribute('data-stack-name') || '',
        line: node.getAttribute('data-stack-line') || '',
        handles: node.getAttribute('data-stack-handles') || '',
        url: node.getAttribute('data-stack-url') || '/pages/bundels'
      };
    });
    var goalToStack = {};
    scope.querySelectorAll('[data-goal-stack]').forEach(function (node) {
      goalToStack[node.getAttribute('data-goal-stack')] = node.getAttribute('data-stack-key');
    });
    var defaultStack = root.getAttribute('data-default-stack') || 'daily';

    function tmpl(str, num) { return (str || '').replace('__N__', num).replace('__T__', total); }

    function updateProgress() {
      var shown = Math.min(current + 1, total);
      var pct = Math.round((shown / total) * 100);
      if (bar) bar.style.width = pct + '%';
      if (pctEl) pctEl.textContent = pct + '%';
      if (counter) counter.textContent = tmpl(counter.getAttribute('data-tmpl'), shown);
      if (live) live.textContent = tmpl(live.getAttribute('data-tmpl'), shown) + ' ' + pct + '%';
    }

    function showStep(i) {
      steps.forEach(function (s, idx) {
        var active = idx === i;
        s.hidden = !active;
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      if (result) { result.hidden = true; result.setAttribute('aria-hidden', 'true'); }
      current = i;
      updateProgress();
      var heading = steps[i].querySelector('[data-quiz-heading]');
      if (heading && typeof heading.focus === 'function') heading.focus();
    }

    function buildResult() {
      var goal = answers.goal;
      var key = (goal && goalToStack[goal]) || defaultStack;
      var stack = stacks[key] || stacks[defaultStack];
      if (!stack) return;
      var nameEl = result.querySelector('[data-result-name]');
      var lineEl = result.querySelector('[data-result-line]');
      var ctaEl = result.querySelector('[data-result-cta]');
      var addEl = result.querySelector('[data-add-bundle]');
      if (nameEl) nameEl.textContent = stack.name;
      if (lineEl && stack.line) lineEl.textContent = stack.line;
      if (ctaEl) ctaEl.setAttribute('href', stack.url);
      if (addEl) {
        addEl.setAttribute('data-handles', stack.handles);
        addEl.removeAttribute('data-label-idle');
      }
      var prodEl = result.querySelector('[data-result-products]');
      var usedKey = stacks[key] ? key : defaultStack;
      var srcNode = scope.querySelector('[data-stack="' + usedKey + '"] .nfp-quiz-stack-products');
      if (prodEl && srcNode) { prodEl.innerHTML = srcNode.innerHTML; }
    }

    function showResult() {
      steps.forEach(function (s) { s.hidden = true; s.setAttribute('aria-hidden', 'true'); });
      buildResult();
      if (bar) bar.style.width = '100%';
      if (pctEl) pctEl.textContent = '100%';
      if (counter) counter.textContent = counter.getAttribute('data-tmpl-done') || counter.textContent;
      if (live) live.textContent = (counter ? counter.textContent : '') + ' 100%';
      if (result) {
        result.hidden = false;
        result.setAttribute('aria-hidden', 'false');
        var h = result.querySelector('[data-result-heading]');
        if (h && typeof h.focus === 'function') h.focus();
      }
    }

    function go(dir) {
      var next = current + dir;
      if (next < 0) return;
      if (next >= total) { showResult(); return; }
      showStep(next);
    }

    // Selecting a radio records the answer and auto-advances.
    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-quiz-input]');
      if (!input) return;
      answers[input.name] = input.value;
      var step = input.closest('[data-quiz-step]');
      if (step) {
        step.querySelectorAll('[data-quiz-option]').forEach(function (opt) {
          opt.classList.toggle('is-selected', opt.contains(input) && input.checked);
        });
      }
    });

    root.addEventListener('click', function (e) {
      var choose = e.target.closest('[data-quiz-choose]');
      if (choose) {
        e.preventDefault();
        var opt = choose.closest('[data-quiz-option]');
        var input = opt && opt.querySelector('[data-quiz-input]');
        if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
        go(1);
        return;
      }
      var next = e.target.closest('[data-quiz-next]');
      if (next) { e.preventDefault(); go(1); return; }
      var back = e.target.closest('[data-quiz-back]');
      if (back) { e.preventDefault(); go(-1); return; }
      var restart = e.target.closest('[data-quiz-restart]');
      if (restart) {
        e.preventDefault();
        answers = {};
        root.querySelectorAll('[data-quiz-input]').forEach(function (i) { i.checked = false; });
        root.querySelectorAll('[data-quiz-option]').forEach(function (o) { o.classList.remove('is-selected'); });
        showStep(0);
      }
    });

    // Enhance: mark ready (CSS reveals nav, hides the no-JS stack), show step 1.
    root.classList.add('quiz-ready');
    showStep(0);
  });
})();
